
export type SubsetKeys<T extends readonly unknown[]> = T[number];

export const subsetOf =
  <T>() =>
    <const Values extends readonly T[]>(values: Values) =>
      values;


export type DefinedDefaults<T, K extends keyof T> = {
  [P in K]-?: Exclude<T[P], undefined>;
};

export type TWithDataComponent = {
  "data-component"?: string;
};
